'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var appTypes = require('../../types/appTypes');
var LabelParts = require('../common/LabelParts');
var assetsHelper = require('../../helper/assetsHelper');
var styleHelper = require('../../helper/styleHelper');
var textHelper = require('../../helper/util').Text;

var BreadCrumbs = React.createClass({

  _getItemArray: function () {
    return textHelper.delimitText(styleHelper.getText(this.props), textHelper.DM_COMMA);
  },

    render: function () {
    var backgroundStyle = {
      width: '100%',
      height: '100%'
    };

    var textArray = this._getItemArray();
    this.len = textArray.length;
    var separatorSrc = assetsHelper.getComponentAsset('commons/separator');
    styleHelper.StyleUtil(this.props).default(backgroundStyle).text();
    return (<div style={backgroundStyle}>
      {
        textArray.map(function (text, index) {
          var css = {width: 'auto', position: 'absolute', whiteSpace: 'nowrap'};
          if(index === textArray.length - 1){
            css.color = '#000';
          }
          return (
            <div key={index} ref={'text_' + index} style={css}>
              <label>{text}</label></div>
          );
        }, this)
      }
      {
        textArray.map(function (t, index) {
          if (index < this.len - 1) {
            return (
              <div key={index} ref={'separator_' + index} style={{width: this.props.gap, position: 'absolute'}}>
                <img style={{position: 'absolute', top: (this.props.h - 10) / 2, left: (this.props.gap - 8) / 2}}
                     src={separatorSrc}/>
              </div>
            );
          }
        }, this)
      }
    </div>);
  },

  componentDidMount: function () {
    var i = 0;
    var txt;
    var separator;
    var left = 0;
    for (i; i < this.len; i++) {
      txt = ReactDOM.findDOMNode(this.refs['text_' + i]);
      separator = ReactDOM.findDOMNode(this.refs['separator_' + i]);

      $(txt).css({left: left});
      left += txt.clientWidth;
      if (separator) {
        $(separator).css({left: left});
        left += separator.clientWidth;
      }
    }
  }

});

module.exports = BreadCrumbs;




// WEBPACK FOOTER //
// ./src/views/Components/BreadCrumbs.jsx